import React from 'react';

function LoadingScreen() {
  return (
    <div 
      className="fixed inset-0 bg-gray-900 light:bg-white flex items-center justify-center z-50 transition-opacity duration-300"
      role="alert"
      aria-label="Loading content"
    >
      <div className="relative">
        <div className="w-16 h-16 border-4 border-blue-500/30 border-t-blue-500 rounded-full animate-spin" />
        <div className="mt-4 text-center">
          <p className="text-gray-400 light:text-gray-600 text-sm">Loading...</p>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;